import StorageService from 'portaltransparencia-common/libs/StorageService.js';

import * as types from './Types.js';

const getEntidade = () => StorageService.getItem('userInfo').entidade.id;

export function findIrps(filter) {
  const suffix = filter ? `&${filter}` : '';

  return ({ fetch }) => ({
    type: types.IRPS,
    payload: {
      promise: fetch(`/api/irp?entidade=${getEntidade()}${suffix}`)
    }
  });
}

export function findModalidades() {
  return ({ fetch }) => ({
    type: types.IRP_MODALIDADES,
    payload: {
      promise: fetch(`/api/irp/modalidades?entidade=${getEntidade()}`)
    }
  });
}

export function findIrp(id) {
  return ({ fetch }) => ({
    type: types.IRP,
    payload: {
      promise: fetch(`/api/irp/${id}?entidade=${getEntidade()}`)
    }
  });
}

export function findItens(id) {
  return ({ fetch }) => ({
    type: types.IRP_ITENS,
    payload: {
      promise: fetch(`/api/irp/${id}/itens?entidade=${getEntidade()}`)
    }
  });
}

export function findArquivos(id) {
  return ({ fetch }) => ({
    type: types.IRP_ARQUIVOS,
    payload: {
      promise: fetch(`/api/irp/${id}/arquivos?entidade=${getEntidade()}`)
    }
  });
}

export function resetConsulta() {
  return {
    type: types.RESET_CONSULTA_IRPS,
    payload: {}
  };
}
